import { encode, decode } from 'js-base64';
import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const localStorageBase64 = () => {
  return {
    setItem: (key, value) => {
      localStorage.setItem(encode(key), encode(value))
    },
    getItem: (key) => {
      const a = localStorage.getItem(encode(key))
      return decode(a || '')
    },
    clear: () => {
      localStorage.clear()
    },
  }
}

const { persistAtom } = recoilPersist({ key: 'EngfoodApp032504035787kkhgsdassss', storage: localStorageBase64() })

/*
export const userState = atom({
  key: 'userState',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

export const managerState = atom({
  key: 'managerState',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

export const garconsState = atom({
  key: 'garconsState',
  default: [],
  effects_UNSTABLE: [persistAtom],
})

export const entregadoresState = atom({
  key: 'entregadoresState',
  default: [],
  effects_UNSTABLE: [persistAtom],
})

export const valorDiariaEntregadorState = atom({
  key: 'valorDiariaEntregadorState',
  default: 0,
  effects_UNSTABLE: [persistAtom],
})

export const garcomSelectedState = atom({
  key: 'garcomSelectedState',
  default: null,
  effects_UNSTABLE: [persistAtom],
})


export const configState = atom({
  key: 'configState',
  default: {},
  effects_UNSTABLE: [persistAtom],
})


export const entregueUltimaHoraState = atom({
  key: 'entregueUltimaHoraState',
  default: true,
  effects_UNSTABLE: [persistAtom],
})
  */

export const deliveryUserState = atom({
  key: 'deliveryUser',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
})

export const deliveryPedidosState = atom({
  key: 'deliveryPedidosState',
  default: [],
  effects_UNSTABLE: [persistAtom],
})

export const deliveryUserEnderecosState = atom({
  key: 'deliveryUserEnderecosState',
  default: [],
  effects_UNSTABLE: [persistAtom],
})

export const deliveryPedidosHistoricoState = atom({
  key: 'deliveryPedidosHistoricoState',
  default: {},
  effects_UNSTABLE: [persistAtom],
})

export const deliveryEnderecosState = atom({
  key: 'deliveryEnderecosState',
  default: [],
  effects_UNSTABLE: [persistAtom],
})


export const deliveryUltimosPedidosState = atom({
  key: 'deliveryUltimosPedidosState',
  default: [],
  effects_UNSTABLE: [persistAtom],
})

//userNoRegister
export const deliveryUserNoRegisterState = atom({
  key: 'deliveryUserNoRegisterState',
  default: { name: '', phone: '' },
  effects_UNSTABLE: [persistAtom],
})
